import { render, staticRenderFns } from "./PRating.vue?vue&type=template&id=56c46b95&scoped=true&"
import script from "./PRating.vue?vue&type=script&lang=ts&"
export * from "./PRating.vue?vue&type=script&lang=ts&"
import style0 from "./PRating.vue?vue&type=style&index=0&id=56c46b95&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56c46b95",
  null
  
)

export default component.exports